import type { GroupMemberInMonth } from "@/api/nurses";

type NurseIdentity = {
  readonly nurse_id: string;
};

export function filterWantedBoardMonthlyNurses<TNurse extends NurseIdentity>(
  nurses: readonly TNurse[] | null | undefined,
  members: readonly GroupMemberInMonth[] | null | undefined
): TNurse[] {
  if (!nurses) return [];
  if (!members) return [...nurses];

  const memberIds = new Set(members.map((member) => String(member.nurse_id)));
  return nurses.filter((nurse) => memberIds.has(String(nurse.nurse_id)));
}
